export default __webpack_public_path__ + "static/media/rear-left-wheel.e8efbbfb.svg";